import axios from 'axios'

export const resourcePath = (resource, archive = false) => `api/v2/admins/${archive ? 'migration_archives' : 'marketing'}/${resource}`
export const assetUrl = (path) => path && new URL(path, axios.defaults.baseURL || window.location.origin).href

export const downloadFile = async (path, params = {}, fallback = 'export.xlsx') => {
  const response = await axios.get(path, { params, responseType: 'blob' })
  const disposition = response.headers['content-disposition'] || ''
  const filename = disposition.match(/filename="?([^";]+)"?/)?.[1] || fallback
  const url = URL.createObjectURL(response.data)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export const errorMessage = async (error) => {
  let data = error.response?.data
  if (data instanceof Blob) {
    try { data = JSON.parse(await data.text()) } catch (_error) { data = null }
  }
  return data?.message || data?.messages?.base || error.message || 'Permintaan gagal.'
}
